import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calculator } from 'lucide-react';
import { Button } from './ui/button';

const EstimationBanner = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-emerald-600 via-emerald-500 to-teal-500 relative overflow-hidden">
      {/* White grid pattern overlay - matching hero banners style */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4 text-white text-center md:text-left">
            <div className="hidden md:flex w-16 h-16 bg-white/20 rounded-2xl items-center justify-center flex-shrink-0">
              <Calculator className="w-8 h-8 text-white" />
            </div>
            <div>
              <p className="text-xl md:text-2xl font-bold leading-tight">
                Estimez le coût de votre débarras en quelques clics
              </p>
              <p className="text-emerald-100 mt-1">
                Gratuit, sans engagement, réponse immédiate
              </p>
            </div>
          </div>
          
          <Link to="/devis" className="flex-shrink-0">
            <Button 
              size="lg" 
              className="bg-white text-emerald-700 hover:bg-emerald-50 shadow-xl text-base px-6 py-6 font-semibold"
            >
              Mon estimation gratuite
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default EstimationBanner;
